import * as gzTime from './time.service';

export default angular.module('gazelle.components.time', [
  'angularMoment',
  'rhino.core',
  'rhino.components.preferences',
])
  .constant('moment', require('moment-timezone'))
  .service(gzTime.name, gzTime.default)
  .name;
